import { render, staticRenderFns } from "./KpiKeyValue.vue?vue&type=template&id=b81235ae&scoped=true&"
import script from "./KpiKeyValue.vue?vue&type=script&lang=js&"
export * from "./KpiKeyValue.vue?vue&type=script&lang=js&"
import style0 from "./KpiKeyValue.vue?vue&type=style&index=0&id=b81235ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81235ae",
  null
  
)

export default component.exports